import { render, staticRenderFns } from "./RoutesMap.vue?vue&type=template&id=a57fe1b4&"
import script from "./RoutesMap.vue?vue&type=script&lang=js&"
export * from "./RoutesMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports